import { Box } from "@mui/material";
import React from "react";

const ListWrap = ({ children }) => {
  return <Box sx={{ margin: "0px 1rem" }}>{children}</Box>;
  
};

export default ListWrap;
